import { render, staticRenderFns } from "./ForumPendingQueue.vue?vue&type=template&id=eb09e082&"
import script from "./ForumPendingQueue.vue?vue&type=script&lang=js&"
export * from "./ForumPendingQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports